import React, { FC } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { isAuthorized } from 'services/localStorage/authentication'

const PrivateRoutes: FC = () =>
  isAuthorized() ? <Outlet /> : <Navigate to="/entrar" replace />

export { PrivateRoutes }
